import { createSelector } from "reselect";
import get from "lodash.get";

export const selectInitializeResponse = state =>
  state.workItems.initializeResponse;

export const selectFieldsResponse = state => state.workItems.fieldsResponse;

export const selectCanSave = state => state.workItems.canSave;

export const selectCurrentWorkItem = state => state.workItems.currentWorkItem;

export const selectCurrentMiscFees = state => state.workItems.miscFees;

export const selectCurrentPre1981Data = state => state.workItems.pre1981Data;

export const selectCurrentWorkItemStateName = createSelector(
  selectCurrentWorkItem,
  workItem => workItem.attributes.stateName
);

export const selectLocationStates = createSelector(
  selectInitializeResponse,
  response => get(response, "location.states", [])
);

export const selectDropDownStates = createSelector(
  selectLocationStates,
  states =>
    states.map(o => ({
      value: o.stateAbbr,
      text: o.stateName
    }))
);

export const selectCurrentWIFees = createSelector(
  selectCurrentWorkItem,
  workItem => {
    const fees = get(workItem, "dualFeesResponse", [])
      .map(fieldsNFees => (fieldsNFees ? fieldsNFees.fees : 0))
      .filter(fees => !!fees);
    return fees.length > 1 ? fees : fees[0];
  }
);

export const selectCurrentWIFields = createSelector(
  selectCurrentWorkItem,
  workItem => get(workItem, "dualFeesResponse[0].fields.fieldDetails", [])
);

export const selectCurrentWIVehicle = createSelector(
  selectCurrentWorkItem,
  selectFieldsResponse,
  (workItem, response) =>
    !response ? get(workItem, "vehicle") : get(response, "vehicle", [])
);

export const selectCurrentWIVehicleObject = createSelector(
  selectCurrentWIVehicle,
  vehicle =>
    vehicle.reduce((obj, x) => {
      if (x.key === "ModelYear") {
        obj.year = x.value;
      } else if (x.key === "VehicleMake") {
        obj.make = x.value;
      } else if (x.key === "VehicleModel") {
        obj.model = x.value;
        }
      return obj;
    }, {})
);

const sortBySequence = (a, b) => {
  a = Number(a.sequence);
  b = Number(b.sequence);
  return a > b ? 1 : a === b ? 0 : -1;
};

export const selectWIReportData = createSelector(
  selectCurrentWIFields,
  fields =>
    fields
      .sort(sortBySequence)
      .filter(x => x.isShowReport === "True")
      .map(obj => ({
        key: obj.key,
        label: obj.name,
        value: obj.value,
        type: obj.type
      }))
);
export const selectWIVehicleReportData = createSelector(
  selectCurrentWIVehicle,
  vehicle =>
    vehicle
      .filter(x => ["ModelYear", "VehicleMake", "VehicleModel"].includes(x.key))
      .map(obj => ({
        key: obj.key,
        label: obj.name,
        value: obj.value
      }))
);

export const selectStateNameReportData = createSelector(
  selectCurrentWorkItemStateName,
  state => ({ key: "StateName", label: "State", value: state, type: "Text" })
);

export const selectWIClaimantData = createSelector(
  selectWIReportData,
  selectStateNameReportData,
  selectWIVehicleReportData,
  (workItemData, stateName, vehicleData) => {
    const prevFieldIndex = workItemData.findIndex(x => x.key === "cRegCity");
    if (prevFieldIndex >= 0) {
      workItemData.splice(prevFieldIndex + 1, 0, stateName);
      return workItemData.concat(vehicleData);
    }
    return workItemData.concat([stateName]).concat(vehicleData);
  }
);

export const selectLocationStateDetails = createSelector(
  selectInitializeResponse,
  response => get(response, "fields.stateDetails", [])
);

export const selectCurrentState = state => state.workItems.currentState || {};

export const selectCurrentStateName = createSelector(
  selectCurrentState,
  selectCurrentWorkItem,
  (currentState, workItem) =>
    currentState && currentState.name
      ? currentState.name
      : get(workItem, "attributes.stateName", "")
);

export const selectCurrentStateAbbr = createSelector(
  selectCurrentState,
  selectCurrentWorkItem,
  (currentState, workItem) =>
    currentState && currentState.abbr
      ? currentState.abbr
      : get(workItem, "attributes.state")
);

export const selectCurrentStateDetails = createSelector(
  selectCurrentStateAbbr,
  selectLocationStateDetails,
  (stateAbbr, stateDetails) =>
    stateDetails
      .filter(c => c.state === stateAbbr)
      .map(desc => desc.description)
);

export const selectFieldDetails = createSelector(
  selectInitializeResponse,
  selectFieldsResponse,
  // (initialResp, fieldsResp) =>
  //   get(fieldsResp || initialResp, "fields.fieldDetails", [])
  (initResp, fieldResp) => {
    return fieldResp
      ? get(fieldResp, "dualFeesResponse[0].fields.fieldDetails", [])
      : get(initResp, "fields.fieldDetails", []);
  }
);

export const selectFormFields = state => state.workItems.formFields;

export const selectEnterDataManually = state => state.workItems.enterDataManually;

export const selectFormFieldByName = fieldName =>
  createSelector(selectFormFields, fields =>
    (fields || []).find(x => x.key === fieldName)
  );

export const selectInitialFormFields = createSelector(
  selectFormFields,
  selectCurrentStateAbbr,
  (fields, stateAbbr) =>
    (fields || []).filter(
      x => x.isInitialize === "True" && x.state === stateAbbr
    )
);

export const selectAdditionalFormFields = createSelector(
  selectFormFields,
    fields => (fields || []).filter(x => x.isInitialize !== "True")
);



export const selectWorkItemMessage = createSelector(
  selectCurrentWorkItem,
  workItem => get(workItem, "messages", [])[0]
);
